import React, { useContext, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'
import Settings from './Settings'
import Recitations from './Recitations';
import Alarms from './Alarms';
import About from './About';
import { AppContext } from '../AppContext';
import { FontAwesome } from '../data/FontAwesome';


export default function Menu() {

    const { showMenu, setShowMenu, deviceSettings, refreshClock, t, isRtl } = useContext(AppContext)
    const [activeTab, setActiveTab] = useState('settings')

    const tabClass = (tab) => 'nav-link fs-4' + (activeTab === tab ? ' active' : '')

    return (
        <Offcanvas placement="end" scroll="false" show={showMenu} onHide={() => setShowMenu(false)} className={'bg-dark ' + (isRtl ? 'app-rtl' : '')}>
            <Offcanvas.Header className='pb-2'>
                <div className='d-flex flex-row w-100 align-items-start justify-content-between'>
                    <div id='topMenu'>
                        <ul className="nav nav-pills">
                            <li className='nav-item'>
                                <button title={t('menu.settings')} className={tabClass('settings')} type="button"
                                    onClick={() => setActiveTab('settings')}>
                                    {FontAwesome.Gear}
                                </button>
                            </li>

                            {navigator.onLine ? (<li className='nav-item'>
                                <button title={t('menu.recitations')} className={tabClass('recitations')} type="button"
                                    onClick={() => setActiveTab('recitations')}>
                                    {FontAwesome.Book}
                                </button>
                            </li>) : null}

                            {deviceSettings.azanCallsEnabled === 'Y' ? (<li className='nav-item'>
                                <button title={t('menu.alarms')} className={tabClass('alarms')} type="button"
                                    onClick={() => setActiveTab('alarms')}>
                                    {FontAwesome.Bell}
                                </button>
                            </li>) : null}

                            <li className='nav-item'>
                                <button title={t('menu.about')} className={tabClass('about')} type="button"
                                    onClick={() => setActiveTab('about')}>
                                    {FontAwesome.Info}
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className='px-3'>
                        <span title={t('menu.close')} onClick={() => { setShowMenu(false) }} className="pointer bg-dark text-secondary fs-2">
                            {FontAwesome.Close}
                        </span>
                    </div>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="tab-content pt-0">
                    {activeTab === 'settings' ? (<div>
                        <div className='px-3'>
                            <Settings />
                            <div className='d-flex flex-row justify-content-between align-items-center gap-3 mt-3'>

                                {!navigator.onLine ? (<div>
                                    <span title={t('common.offlineHint')} className='badge'>
                                        {FontAwesome.Plug} {t('common.offline')}
                                    </span>
                                </div>) : null}

                                {navigator.onLine ? (<div className='col-6'>
                                    <button className='btn btn-sm col-12 btn-primary' type='button' onClick={refreshClock}>{t('common.refresh')}</button>
                                </div>) : null}

                                {navigator.onLine ? (<div className='col-6'>
                                    <a className='btn btn-sm col-12 btn-danger' href="/reset/">{t('common.reset')}</a>
                                </div>) : null}

                            </div>
                        </div>
                    </div>) : null}
                    {activeTab === 'recitations' ? (<div>
                        <div className='px-3 text-light'>
                            <Recitations />
                        </div>
                    </div>) : null}
                    {activeTab === 'about' ? (<div>
                        <div className='px-3 text-light'>
                            <About />
                        </div>
                    </div>) : null}
                    {activeTab === 'alarms' ? (<div>
                        <div className='px-3 text-light'>
                            <Alarms />
                        </div>
                    </div>) : null}
                </div>
            </Offcanvas.Body>
        </Offcanvas >
    )
}



